import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'

import type { ContentProps } from './Content.interface'

const getCashbackContent = ({ creditCard }: ContentProps) => {
    return [
        guaranteedAprContent({ creditCard }),
        representativeAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        noMinimumGuaranteedCreditLimitContent({
            creditCard,
        }),
    ]
}

export default getCashbackContent
